import React from 'react';
import { Box, Card, CardContent, List, Typography } from '@mui/material';
import LinkGroupItem from './LinkGroupItem';
import { getServerBaseUrl } from '../../api';

const CARD_HEIGHT = 176;

const LinkGroupCard = ({ group }) => {
  const { title, items = [], iconName } = group || {};
  const iconValue = (iconName ?? '').toString().trim();
  const normalizedIconValue = iconValue.startsWith('uploads/') ? `/${iconValue}` : iconValue;
  const isAbsoluteUrl = /^https?:\/\//.test(normalizedIconValue);
  const isUploadsPath = normalizedIconValue.startsWith('/uploads/');
  const isImageIcon = isAbsoluteUrl || isUploadsPath;
  const iconSrc = isUploadsPath ? `${getServerBaseUrl()}${normalizedIconValue}` : normalizedIconValue;

  return (
    <Card
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '1px solid #EAEAEA',
        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        height: CARD_HEIGHT,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <CardContent sx={{ p: 2.5, '&:last-child': { pb: 2.5 }, flex: 1, display: 'flex', flexDirection: 'column' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mb: 2 }}>
          {iconValue ? (
            isImageIcon ? (
              <Box
                component="img"
                src={iconSrc}
                alt=""
                sx={{ width: 24, height: 24, objectFit: 'contain' }}
              />
            ) : (
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 22,
                  lineHeight: 1,
                }}
              >
                {iconValue}
              </Box>
            )
          ) : (
            <Box sx={{ width: 24, height: 24 }} />
          )}
          <Typography
            noWrap
            sx={{
              fontSize: 16.5,
              fontWeight: 700,
              color: '#000',
              letterSpacing: '-0.5px',
              flex: 1,
              minWidth: 0,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            {title || '링크 그룹'}
          </Typography>
        </Box>
        <List dense disablePadding sx={{ display: 'flex', flexDirection: 'column', gap: 1.5, flex: 1 }}>
          {items.slice(0, 3).map((item, idx) => (
            <LinkGroupItem key={item.id || `${title}-${idx}`} item={item} />
          ))}
        </List>
      </CardContent>
    </Card>
  );
};

export default LinkGroupCard;


